import {useEffect, useRef, useState} from "preact/hooks";

const TRANSPARENT_PIXEL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

export function LazyImage({src, onError, fallbackSrc = "/img/Portrait_Placeholder.png", ...props}) {
    const imageRef = useRef(null);
    const [shouldLoad, setShouldLoad] = useState(false);
    const [prevSrc, setPrevSrc] = useState(src);
    
    if (src !== prevSrc) {
        setShouldLoad(false);
        setPrevSrc(src);
    }
    
    const resolvedSrc = shouldLoad && src ? src : TRANSPARENT_PIXEL;

    useEffect(() => {
        const imageElement = imageRef.current;

        if (!imageElement || shouldLoad) {
            return;
        }

        if (!("IntersectionObserver" in window)) {
            setShouldLoad(true);
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                setShouldLoad(true);
                observer.disconnect();
            }
        });

        observer.observe(imageElement);

        return () => observer.disconnect();
    }, [shouldLoad, src]);

    const handleError = (event) => {
        if (event.currentTarget.src !== fallbackSrc) {
            event.currentTarget.src = fallbackSrc;
        }

        if (onError) {
            onError(event);
        }
    };

    return (
        <img
            {...props}
            ref={imageRef}
            src={resolvedSrc}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            onError={handleError}
        />
    );
}
